import { Component } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AppService } from 'briteatlib';
import { BriteatHomeComponent } from '../../components/briteat/briteat-home/briteat-home.component';
import { BriteatHqHomeComponent } from '../../components/briteat/briteat-hq-home/briteat-hq-home.component';
import { BusinessHomeComponent } from '../../components/business/business-home/business-home.component';

@Component({
  selector: 'brt-home-page',
  standalone: true,
  // BriteatHomeComponent is used eagerly (the primary briteat.co.uk landing page, SSR'd).
  // BusinessHomeComponent and BriteatHqHomeComponent are referenced only inside @defer
  // blocks in the template, so the compiler splits them into their own lazy chunks and
  // keeps them out of the primary homepage's initial bundle — they are only fetched when
  // the current domain actually resolves to a business or an HQ.
  imports: [BriteatHomeComponent, BusinessHomeComponent, BriteatHqHomeComponent],
  templateUrl: './home-page.component.html',
  styleUrl: './home-page.component.scss'
})
export class HomePageComponent {
  business: any;
  hq: any;

  constructor(private appService: AppService) {
    appService.activeBusiness$.pipe(takeUntilDestroyed()).subscribe(_ => this.business = _);
    appService.activeHq$.pipe(takeUntilDestroyed()).subscribe(_ => this.hq = _);
  }
}
